export default Object.freeze({
  CONTINUE: 'CONTINUE',
  STOP: 'STOP',
  COMPLETE: 'COMPLETE',
});
